import ContactModel from './contact.model';
// Assuming 'utils' and 'api' are available globally or imported from your project's common utilities
// Example if they need to be imported:
// import utils from '@/path/to/your/utils';
// import api from '@/path/to/your/api';

let storeContent = utils.generateStore({
	ContactModel,
	activeAccordion: 0,
});

export default {
	namespaced: true, // Recommended: Add namespacing to your module for better organization
	state() {
		return { ...storeContent.state };
	},
	getters: {
		...storeContent.getters,
		// If ContactModel is just a state property, generateStore likely makes it a getter.
		// If you need custom getters, define them here:
		// getContactModel: (state) => state.ContactModel,
	},
	mutations: {
		...storeContent.mutations,
		// Add other mutations specific to contact if needed
		// resetContactForm(state) {
		//   state.ContactModel = { ...ContactModel }; // Reset to initial model
		//   state.activeAccordion = 0;
		// }
	},
	actions: {
		openAccordion(ctx, number) {
			ctx.commit('activeAccordion', number);
		},
		async sendMessage(ctx, payload) {
			try {
				ctx.commit('loading', true, { root: true }); // Commit to root 'loading' if it's in globalStore
				let data = payload.ref.formData_;

				if (await payload.ref.isValid()) {
					await api.fetchEndpoint({
						resource: 'contact',
						action: 'send_message',
						data: {
							first_name: data.first_name,
							last_name: data.last_name,
							email: data.email,
							category: data.category,
							message: data.message,
						},
					});

					$notify(
						'success',
						'Message Sent',
						'Thank you for contacting us! We will get back to you soon.',
						10,
					);
					payload.ref.reset();
					// ctx.commit('resetContactForm'); // Uncomment if you add this mutation
				}
			} catch (err) {
				$notify(
					'error',
					'Error',
					'Failed to send message. Please try again later.',
				);
				throw err;
			} finally {
				ctx.commit('loading', false, { root: true }); // Commit to root 'loading'
			}
		},
	},
};
